// extracted by mini-css-extract-plugin
export var dropdownButton = "_1r-0";
export var fullWidthDropdownButton = "_1r-1";
export var icon = "_1r-3";
export var iconPlaceholder = "_1r-2";
export var shortcutContainer = "_1r-4";